import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#151515\" d=\"M21 16a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h3.343c.263.745.67 1.423 1.186 2H4v3h16v-3h-3.53a6 6 0 0 0 1.187-2z\"></path><path fill=\"#FF760A\" fill-rule=\"evenodd\" d=\"M10 2a1 1 0 0 1 1 1v2h2V3a1 1 0 1 1 2 0v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1\" clip-rule=\"evenodd\"></path><path fill=\"#151515\" fill-rule=\"evenodd\" d=\"M12 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0 2a6 6 0 1 0 0-12 6 6 0 0 0 0 12\" clip-rule=\"evenodd\"></path><path fill=\"#151515\" fill-rule=\"evenodd\" d=\"M14.207 11.793a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 0 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0\" clip-rule=\"evenodd\"></path><path fill=\"#151515\" fill-rule=\"evenodd\" d=\"M2 3.5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2V14a1 1 0 1 1-2 0V3.5H4V14a1 1 0 1 1-2 0z\" clip-rule=\"evenodd\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_7]))
}
export default { render: render }